export const FALLBACK_IMAGES = {
    EBOOK: "https://ajuda.nossomundoazul.com.br/other-assets/ebook-fallback.jpg",
    DOWNLOAD: "https://ajuda.nossomundoazul.com.br/other-assets/download-fallback.jpg",
    ARTICLE: "https://ajuda.nossomundoazul.com.br/other-assets/artigos-fallback.jpg",
    MULTIMEDIA: "https://ajuda.nossomundoazul.com.br/other-assets/multimidia-fallback.jpg"
} as const;